import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Routes } from 'src/constants/index';
import { BlueButton } from 'src/components/components/index';
import './style.scss';

export class ConciergeContact extends Component {
  render(): React.ReactNode {
    return (
      <div className="contact-wrapper">
        <div className="contact-wrapper__wrapper">
          <p className="contact-wrapper__paragraph">
            <FormattedMessage id="concierge.contact.paragraph" />
          </p>
          <Link to={Routes.ContactUs}>
            <BlueButton>
              <FormattedMessage id="concierge.contact.button" />
            </BlueButton>
          </Link>
        </div>
      </div>
    );
  }
}
